import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Gets a user's settings
 * Gets a user's settings. Can only call this for the logged in user. API validate class_language_preference values that client send before saving it to database. If user selects display all classes without any condition then value of display_all_classes field will be True and there will no captions field for that setting. If user selects classes with any caption condition then value of display_all_classes will be False and under caption fields there will be all language that user selected for caption.
 * @param id
 * @returns UserSettingsResponse Successful response
 * @throws ApiError
 */

export var getUserSettings = function getUserSettings(api, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(id, "/settings");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Sets an existing user's setting info
 * Updates the logged in user's settings and returns all of that user's settings. The peloton client details header is expected to contain `workout_id` when closed captions are toggled on or off in addition to the base properties.
 * @param id This must be the signed in user's id, or this endpoint will return an authentication failure
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @param requestBody
 * @returns UserSettingsResponse Successful response
 * @throws ApiError
 */

export var putUserSettings = function putUserSettings(api, id, pelotonPlatform, pelotonClientDetails, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user/".concat(id, "/settings");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get url to upload image to
 * Gets a presigned url that can be PUT to in order to upload a new image for that user. Additionally returns new_image_url, which will be the url of the image uploaded with the presigned url. To Use: (1) Use this endpoint to get a presigned url, and a new image url. (2) Make a PUT request with the presigned url, with your new image file as the body. Use the header {Content-type: 'application/octet-stream'} to ensure request headers match those expected by the presigned url. (3) Update the user within 10 minutes of generating a presigned url by making a PUT request to /user/id with a message body that includes "image_url"=<new_image_url>, where new_image_url is the new image url you obtained in step (1).
 * @param id This must be the signed in user's id, or this endpoint will return an authentication failure
 * @returns any Successful response
 * @throws ApiError
 */

export var userImageUploadUrl = function userImageUploadUrl(api, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(id, "/image_upload_url");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Updates a remote add shared users shared user added property
 * Updates a remote add shared users shared user added property
 * @param userId
 * @param remoteAddSharedUserId
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shard User.
 * @throws ApiError
 */

export var updateRemoteAddSharedUserShareUserAdded = function updateRemoteAddSharedUserShareUserAdded(api, userId, remoteAddSharedUserId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/shared_user_added");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Sends user's watch token to Braze
 * Makes POST request to Braze's /users/track endpoint to associate user push watch token with the braze app id. Requires logged in user.
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var watchToken = function watchToken(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/watch_token";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Basic Peloton Account Information
 * Checks if an account exists for a given email and if it does returns some high level information about that account
 * @param email email address to check
 * @returns any Found an account and returned basic information including has_subscriptions, has_password_set, and has_payment_on_file. has_subscriptions will include cancelled subscriptions but not transferred subscriptions, since they can not be reactivated. has_payment_on_file will also return True if the user has one subscription associated with their account and it is a 39month financed subscription.
 * @throws ApiError
 */

export var basicAccountInfo = function basicAccountInfo(api, email) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/basic_account_info";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof email !== 'undefined') {
    localVarQueryParameter['email'] = email;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Return Access Token for ThirdParty access to Peloton Endpoints
 * Returns Access Token which allows registered thirdparty users to access Peloton's endpoint.
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var getAccessToken = function getAccessToken(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/public/login";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Deletes data associated with user
 * Deletes Engagement and Ecommerce data associated with specified user, except that which is required for us to keep for our records according to Peloton Legal. Used for integration with Boomi and requires the 'boomi:write' scope.
 * @param userId
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var deleteUserAccountData = function deleteUserAccountData(api, userId, requestBody) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/internal/user/".concat(userId, "/delete_account_data");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Ends the user onboarding process of a remote device activation
 * Ends User Onboarding by the client/device for the remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var endUserOnboardingRemoteDeviceActivation = function endUserOnboardingRemoteDeviceActivation(api, userId, remoteDeviceActivationId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/end_user_onboarding");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get all of the future reservations for the currently logged-in user
 * Returns a list reservations for the currently logged-in user. These reservations are for future or in-progress live classes.
 * @param id ID for the user.
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserReservations = function getUserReservations(api, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(id, "/reservations");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Indicates whether logged in user's birthday is confirmed old enough
 * Evaluates if the logged in user's birthday is specified and makes them old enough
 * @returns any Successful response
 * @throws ApiError
 */

export var isUserOldEnough = function isUserOldEnough(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/api/user/old_enough";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Creates a remote device activation
 * Creates a new remote device activation underneath the user
 * @param userId
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param productModel Can be used to identify the different bike and tread models. If not provided then the product_model will default to:
 * - v1_bike for home_bike and commercial_bike.
 * - aurora for home_tread.
 *
 * @param requestBody
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var createRemoteDeviceActivation = function createRemoteDeviceActivation(api, userId, pelotonPlatform, productModel, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Product-Model'] = String(productModel);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a user's information
 * Return user information. Private information will also be included if the user being requested is the currently logged-in user (Private information including birthday, email, heart rate zones, subscriptions, etc.) Aurora content will be hidden unless aurora platform is specified in header If this user's profile is private and the logged-in user does not follow them, most fields will be null. Not null fields are id, username, location, profile_image, is_profile_private and relationship. Note 1: this returns two fields that are not part of the user mapping (streaks and relationships) Note 2: Only required contracts are returned. To retrieve optional contracts use GET /api/user/{id}/contract_agreements
 * @param id
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param isOnboarded Name of the feature to check onboarding status on (example usage, "is_onboarded=hestia"). It will also accept a comma-separated list of features to get the onboarding status of each feature (ex. "is_onboarded=wolfpack,tooltips").
 * @returns any Successful response
 * @throws ApiError
 */

export var getUser = function getUser(api, id, pelotonPlatform, isOnboarded) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(id);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof isOnboarded !== 'undefined') {
    localVarQueryParameter['is_onboarded'] = isOnboarded;
  }

  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Sets updated info for an existing user
 * Updates the logged in user's information and returns all of that user's information.
 * @param id This must be the signed in user's id, or this endpoint will return an authentication failure
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var putUser = function putUser(api, id, pelotonPlatform, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(id);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Acknowledges the device attachment of a remote device activation
 * Acknowledges by the client/device that the remote device activation was attached
 * @param userId
 * @param remoteDeviceActivationId
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var acknowledgeRemoteDeviceActivation = function acknowledgeRemoteDeviceActivation(api, userId, remoteDeviceActivationId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/acknowledge_device_attachment");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Update a user's quick hits settings
 * This endpoint will update the backend to store quick hits (a user's custom set speed and incline shortcuts)
 * @param requestBody QuickHits
 * @returns QuickHits All quick hits entries are successfully saved in the database
 * @throws ApiError
 */

export var updateQuickHits = function updateQuickHits(api, requestBody) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/quick_hits";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get all of the future reservations for the currently logged-in user
 * Returns a list reservations for the currently logged-in user. These reservations are for future or in-progress live classes.
 * @returns any Successful response
 * @throws ApiError
 */

export var getOwnReservations = function getOwnReservations(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/api/user/reservations";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get users tiering info
 * Get users tiering info
 * @returns any Successful response
 * @throws ApiError
 */

export var membershipTieringInfo = function membershipTieringInfo(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/api/membership/tiering_info";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Resets the expiration for a remote add shared users
 * Resets the expiration for a remote add shared users
 * @param userId
 * @param remoteAddSharedUserId
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shared User.
 * @throws ApiError
 */

export var resetExpirationRemoteAddSharedUsers = function resetExpirationRemoteAddSharedUsers(api, userId, remoteAddSharedUserId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/reset_expiration");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Search for Users
 * Returns a list of users that match the search query.
 * The users include three categories, depending on the relationship with
 * logged-in-user:
 * * 'self' is the logged-in-user,
 * * 'following' are the users followed by the logged-in-user,
 * * 'others' are the rest.
 *
 * The order of user list is:
 * 1. The logged-in user
 * 2. Users that follow the logged-in user, but that the logged-in user
 * does not follow.
 * 3. Users that follow the logged-in user and the logged-in user follows.
 * 4. Users that the logged-in user follows, but that do not follow the
 * logged-in user.
 * 5. Everyone else.
 *
 * The users are sorted alphabetically by username in each of the above.
 * @param query The query to search by. It can have one of three forms, an email address, a username, or a first name and a last name separated by a space. In the case of a first and last name, these can also be reversed. In any case, this will return all users where the beginning of that field matches the query.
 * @param limit If set, returns a limited number of data up to the limit specified. If not set, whole data will be returned.
 * @param page If set, retrieve data of this page number. Default to be 0.
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserByQuery = function getUserByQuery(api, query, limit, page) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/search/".concat(query);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof page !== 'undefined') {
    localVarQueryParameter['page'] = page;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Peloton Counted-in Users
 * Returns a list of counted-in users of the class, which includes three categories: * 'self' if the logged-in user is counted in, * 'following' if the users followed by the logged-in user are counted in, * 'others' for the rest of users that are counted in. The order of user list is: 1. The logged-in user (if following the request user) 2. Users that follow the logged-in user and the logged-in user follows. 3. Users that the logged-in user follows, but that do not follow the logged-in user. 4. Users that follow the logged-in user, but that the logged-in user does not follow. 5. Everyone else. The users are sorted alphabetically by username in each of the above.
 * @param id The peloton id
 * @param limit If set, returns a limited number of data up to the limit specified. If not set, whole data will be returned.
 * @param page If set, retrieve data of this page number. Default to be 0.
 * @returns any Successful response
 * @throws ApiError
 */

export var getCountedInUsers = function getCountedInUsers(api, id, limit, page) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/peloton/".concat(id, "/counted_in_users");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof page !== 'undefined') {
    localVarQueryParameter['page'] = page;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Fetches the user onboarding events for a given remote device activation
 * Fetches the user onboarding events for a given remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @param eventsAfterId filters resutls to only contain events after the given id (defaults to all if the id cannot be found)
 * @returns any Successful response. Returns Remote User Onboarding Events
 * @throws ApiError
 */

export var getRemoteDeviceActivationUserOnboardingEvents = function getRemoteDeviceActivationUserOnboardingEvents(api, userId, remoteDeviceActivationId, eventsAfterId) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/remote_user_onboarding_events");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof eventsAfterId !== 'undefined') {
    localVarQueryParameter['events_after_id'] = eventsAfterId;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Creates a user onboarding event for a given remote device activation
 * Creates a user onboarding event for a given remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @param requestBody
 * @returns any Successful creation.
 * @throws ApiError
 */

export var createRemoteDeviceActivationUserOnboardingEvents = function createRemoteDeviceActivationUserOnboardingEvents(api, userId, remoteDeviceActivationId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/remote_user_onboarding_events");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Updates a remote add shared users user onboarding ended property
 * Updates a remote add shared users user onboarding ended property
 * @param userId
 * @param remoteAddSharedUserId
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shared User.
 * @throws ApiError
 */

export var updateRemoteAddSharedUserUserOnboardingEnded = function updateRemoteAddSharedUserUserOnboardingEnded(api, userId, remoteAddSharedUserId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/end_user_onboarding");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Claims the next unclaimed remote add shared user
 * Claims the next unclaimed remote add shared user
 * @param userId
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shared User.
 * @throws ApiError
 */

export var claimRemoteAddSharedUser = function claimRemoteAddSharedUser(api, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/claim");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Creates a remote add shared user
 * Creates a new remote add shared user underneath the user
 * @param userId
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param productModel Can be used to identify the different bike and tread models. If not provided then the product_model will default to:
 * - v1_bike for home_bike and commercial_bike.
 * - aurora for home_tread.
 *
 * @param requestBody
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shard User
 * @throws ApiError
 */

export var createRemoteAddSharedUser = function createRemoteAddSharedUser(api, userId, pelotonPlatform, productModel, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Product-Model'] = String(productModel);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Claims the next unclaimed remote device activation
 * Claims the next unclaimed remote device activation
 * @param userId
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var claimRemoteDeviceActivation = function claimRemoteDeviceActivation(api, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/claim");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Verifies if given birthdate would make a user old enough
 * Verifies if given birthdate would make a user old enough given the passed in country, or the logged in user's subscription country or the session country Notes on passing in country: ---no need to pass country in if user is logged in and has a subscription ---Session country is not always accurate for all clients (e.g. for Web does not necessarily represent TLD, so relying on the session country is not preferred)
 * @param birthday epoch time in seconds of birthdate e.g. 955738116
 * @param country country code (e.g. 'US'). REQUIRED if country cannot be retrieved from logged in user's subscription or Session (via Netlify or Cloudflare country headers)
 * @returns any Successful response
 * @throws ApiError
 */

export var isBirthdayOldEnough = function isBirthdayOldEnough(api, birthday, country) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/birthday/".concat(birthday, "/old_enough");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof country !== 'undefined') {
    localVarQueryParameter['country'] = country;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Resets the expiration of a remote device activation
 * Resets the expiration of a remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var resetExpirationRemoteDeviceActivation = function resetExpirationRemoteDeviceActivation(api, userId, remoteDeviceActivationId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/reset_expiration");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Peloton Joined Users
 * Returns the TOTAL number of users that have joined the class and a list of details for a LIMITED number of users of three categories: * 'self' if the logged-in user has joined the class, * 'following' if the users followed by the logged-in user have joined the class, * 'others' that have joined the class (if self + following do not hit the limit of 5) The order of user list is: 1. The logged-in user (if following the request user) 2. Users that follow the logged-in user and the logged-in user follows. 3. Users that the logged-in user follows, but that do not follow the logged-in user. 4. Users that follow the logged-in user, but that the logged-in user does not follow. 5. Everyone else. The users are sorted alphabetically by username in each of the above.
 * @param id The peloton id
 * @param limit deprecated, any value passed in will be ignored. The limit is not editable (it is 5). parameter is retained for backwards-compatibility
 * @param page deprecated, any value passed in will be ignored. parameter is retained for backwards-compatibility
 * @returns any Successful response
 * @throws ApiError
 */

export var getJoinedPelotonUsers = function getJoinedPelotonUsers(api, id, limit, page) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/peloton/".concat(id, "/joined_users");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof page !== 'undefined') {
    localVarQueryParameter['page'] = page;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Attaches a device using a remote device activation
 * Attaches a device using a subscription id through a remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @param requestBody
 * @returns Subscription Activated subscription with user and attached to device
 * @throws ApiError
 */

export var attachDeviceRemoteDeviceActivation = function attachDeviceRemoteDeviceActivation(api, userId, remoteDeviceActivationId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/attach_device");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Create a new user
 * Creates a new user with specified email and password.
 * Can optionally specify contracts to which the user has agreed. The available
 * contracts can be found by requesting the api/docs endpoint.
 * Triggers Created Account event to be sent to analytics.
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @param requestBody
 * @returns UserMapping Successful response
 * @throws ApiError
 */

export var createUser = function createUser(api, pelotonPlatform, pelotonClientDetails, acceptLanguage, requestBody) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Checks if a user is able to view another user
 * @param userId
 * @param otherUserId
 * @param pelotonTotpToken An 8-digit TOTP (time-based HMAC one-time password) using SHA1. Please contact the API team for
 * the shared secret.
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var userCanViewUser = function userCanViewUser(api, userId, otherUserId, pelotonTotpToken) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/internal/user/can_view_user";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof userId !== 'undefined') {
    localVarQueryParameter['user_id'] = userId;
  }

  if (typeof otherUserId !== 'undefined') {
    localVarQueryParameter['other_user_id'] = otherUserId;
  }

  localVarHeaderParameter['Peloton-TOTP-Token'] = String(pelotonTotpToken);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Fetches a remote add shared user by id
 * Fetches a remote add shared user by id
 * @param userId
 * @param remoteAddSharedUserId
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shard User.
 * @throws ApiError
 */

export var getRemoteAddSharedUser = function getRemoteAddSharedUser(api, userId, remoteAddSharedUserId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Search for Users
 * Returns a list of users that match the search query.
 * The users include three categories, depending on the relationship with
 * logged-in-user:
 * * 'self' is the logged-in-user,
 * * 'following' are the users followed by the logged-in-user,
 * * 'others' are the rest.
 *
 * The order of user list is:
 * 1. The logged-in user
 * 2. Users that follow the logged-in user, but that the logged-in user
 * does not follow.
 * 3. Users that follow the logged-in user and the logged-in user follows.
 * 4. Users that the logged-in user follows, but that do not follow the
 * logged-in user.
 * 5. Everyone else.
 *
 * The users are sorted alphabetically by username in each of the above.
 * @param userQuery The query to search by. It can have one of three forms, an email address, a username, or a first name and a last name separated by a space. In the case of a first and last name, these can also be reversed. In any case, this will return all users where the beginning of that field matches the query.
 * @param limit If set, returns a limited number of data up to the limit specified. If not set, whole data will be returned.
 * @param page If set, retrieve data of this page number. Default to be 0.
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserByQueryByParameter = function getUserByQueryByParameter(api, userQuery, limit, page) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/search";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof userQuery !== 'undefined') {
    localVarQueryParameter['user_query'] = userQuery;
  }

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof page !== 'undefined') {
    localVarQueryParameter['page'] = page;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Create a Digital Guest Pass and Email it to the User
 * Creates and stores a new access code, and enqueues an email to be sent to the members with the access code. The member can then forward the access code so non-Peloton members can  get access to a (possibly extended) digital subscription free trial
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @returns any No content
 * @throws ApiError
 */

export var createDigitalGuestPassEmail = function createDigitalGuestPassEmail(api, pelotonPlatform, pelotonClientDetails) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/guestPass/email";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Cancels the remote device activation
 * Cancels the given remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @param requestBody
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var cancelRemoteDeviceActivation = function cancelRemoteDeviceActivation(api, userId, remoteDeviceActivationId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/cancel");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Check if user exists
 * Checks whether user exists using one of their username or email. Returns True if user exists, False if not.
 * @param email
 * @param username
 * @returns any Successful response
 * @throws ApiError
 */

export var checkUserExists = function checkUserExists(api, email, username) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/exists";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof email !== 'undefined') {
    localVarQueryParameter['email'] = email;
  }

  if (typeof username !== 'undefined') {
    localVarQueryParameter['username'] = username;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a remote device activation
 * Gets the remote device activation underneath the user given the remote activation id
 * @param userId
 * @param remoteDeviceActivationId
 * @returns RemoteDeviceActivation Successful response. Returns Remote Device Activation
 * @throws ApiError
 */

export var getRemoteDeviceActivation = function getRemoteDeviceActivation(api, userId, remoteDeviceActivationId) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets user ID from user account email
 * Used for deletion integration with Boomi so requires the 'boomi:write' scope.
 * @param email
 * @returns any User ID, if any, for email is found
 * @throws ApiError
 */

export var userIdFromEmail = function userIdFromEmail(api, email) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/internal/user_id_matching_email/".concat(email);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Cancels a remote add shared user
 * Cancels a remote add shared user
 * @param userId
 * @param remoteAddSharedUserId
 * @param requestBody
 * @returns RemoteAddSharedUser Successful response. Returns Remote Add Shared User.
 * @throws ApiError
 */

export var cancelRemoteAddSharedUser = function cancelRemoteAddSharedUser(api, userId, remoteAddSharedUserId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/cancel");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Determine the Guest Pass sku for a given user
 * Returns the Guest Pass SKU/Trial length for a given user id. This endpoint will be used for the MVP until a specific sku/free trial length is chosen. Prior to the trial, this endpoint will default to a SKU for a 60 day trial
 * @returns GuestPassSku The sku for the requesting user
 * @throws ApiError
 */

export var getGuestPassSku = function getGuestPassSku(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localVarPath = "/api/user/guestPassSku";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Set the logged in user's password
 * Set the logged in user's password.
 * @param id ID for the user
 * @param requestBody
 * @returns any Successful response
 * @throws ApiError
 */

export var setUserPassword = function setUserPassword(api, id, requestBody) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(id, "/set_password");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Attaches a device using a remote device activation
 * Attaches a device using an activation key through a remote device activation
 * @param userId
 * @param remoteDeviceActivationId
 * @param requestBody
 * @returns Subscription Activated subscription with user and attached to device
 * @throws ApiError
 */

export var attachDeviceWithActivationKeyRemoteDeviceActivation = function attachDeviceWithActivationKeyRemoteDeviceActivation(api, userId, remoteDeviceActivationId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_device_activations/").concat(remoteDeviceActivationId, "/attach_device_with_activation_key");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets basic user information for a batch of users identified by ID
 * Return basic user properties for each user specified by ID. Private user information such as total_workouts will be set to null if the user's profile is private and the logged in user is null or not a follower. Limited to 100 user IDs at a time.
 * @param ids comma-separated list of user IDs to get
 * @returns UserBasicMapping Successful response
 * @throws ApiError
 */

export var getUserBatch = function getUserBatch(api, ids) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/internal/batch/users";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof ids !== 'undefined') {
    localVarQueryParameter['ids'] = ids;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a logged in user's information
 * Return logged in user information. Information will not be sent if the user is not logged-in. (Private information including birthday, email, heart rate zones, subscriptions, etc.) Aurora content will be hidden unless aurora platform is specified in header. Urls for the required legal contracts are also returned with the time at which the user agreed to the contract and the time the contract was created. The correct contract will be returned based on the locale country. Optional contracts are not returned by this endpoint. To retrieve optional contracts use GET /api/user/{id}/contract_agreements
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var getMe = function getMe(api, pelotonPlatform) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/me";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get the user feed
 * Gets the user message feed for the user identified by the given id. If specified, limits the number of results
 * @param id
 * @param limit
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserFeed = function getUserFeed(api, id, limit) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(id, "/feed");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Update a user's hardware settings.
 * This endpoint will update the backend to store user's hardware settings for a certain hardware type.
 * @param hardwareType Hardware type, tread or caesar.
 * @param requestBody Schema can be UserTreadHardWareSettings or UserCaesarHardWareSettings
 * @returns any Successful response. Content schema is UserTreadHardWareSettings, or UserCaesarHardWareSettings.
 * @throws ApiError
 */

export var updateUserHardwareSettings = function updateUserHardwareSettings(api, hardwareType, requestBody) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/me/hardware_settings/".concat(hardwareType);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'PUT'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Fetches the user onboarding events for a given remote add shared user
 * Fetches the user onboarding events for a given remote add shared user
 * @param userId
 * @param remoteAddSharedUserId
 * @param eventsAfterId filters resutls to only contain events after the given id (defaults to all if the id cannot be found)
 * @returns any Successful response. Returns Remote User Onboarding Events
 * @throws ApiError
 */

export var getRemoteAddSharedUserUserOnboardingEvents = function getRemoteAddSharedUserUserOnboardingEvents(api, userId, remoteAddSharedUserId, eventsAfterId) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/remote_user_onboarding_events");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof eventsAfterId !== 'undefined') {
    localVarQueryParameter['events_after_id'] = eventsAfterId;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Creates a user onboarding event for a given remote add shared user
 * Creates a user onboarding event for a given remote add shared user
 * @param userId
 * @param remoteAddSharedUserId
 * @param requestBody
 * @returns any Successful creation.
 * @throws ApiError
 */

export var createRemoteAddSharedUserUserOnboardingEvents = function createRemoteAddSharedUserUserOnboardingEvents(api, userId, remoteAddSharedUserId, requestBody) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/remote_add_shared_users/").concat(remoteAddSharedUserId, "/remote_user_onboarding_events");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Create a Digital Guest Pass
 * Creates, stores, and returns a new access code non-Peloton members can use  to get access to a (possibly extended) digital subscription free trial
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @returns GuestPassAccessCode A new Guest Pass access code was created and saved in the database
 * @throws ApiError
 */

export var createDigitalGuestPass = function createDigitalGuestPass(api, pelotonPlatform, pelotonClientDetails) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/guestPass";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};